var styles = {
  "main": "_main_ia2wq9_17",
  "rs-reset-letter-spacing": "_rs-reset-letter-spacing_ia2wq9_1",
  "busy": "_busy_ia2wq9_49",
  "busyOverlay": "_busyOverlay_ia2wq9_53",
  "light": "_light_ia2wq9_59",
  "disabled": "_disabled_ia2wq9_61",
  "dark": "_dark_ia2wq9_62",
  "alignIconLeft": "_alignIconLeft_ia2wq9_78",
  "alignIconRight": "_alignIconRight_ia2wq9_82",
  "sizeXs": "_sizeXs_ia2wq9_86",
  "sizeS": "_sizeS_ia2wq9_93",
  "sizeM": "_sizeM_ia2wq9_100",
  "sizeL": "_sizeL_ia2wq9_107",
  "allowMultiline": "_allowMultiline_ia2wq9_115",
  "multiline": "_multiline_ia2wq9_119",
  "withoutText": "_withoutText_ia2wq9_139",
  "withIcon": "_withIcon_ia2wq9_145",
  "busyIcon": "_busyIcon_ia2wq9_151",
  "flatRight": "_flatRight_ia2wq9_159",
  "flatLeft": "_flatLeft_ia2wq9_164",
  "modeClassic": "_modeClassic_ia2wq9_169",
  "modeRock": "_modeRock_ia2wq9_242",
  "modeTransparent": "_modeTransparent_ia2wq9_320",
  "modeOutline": "_modeOutline_ia2wq9_390",
  "modeClear": "_modeClear_ia2wq9_479",
  "highlighted": "_highlighted_ia2wq9_514",
  "shiftedLeft": "_shiftedLeft_ia2wq9_565",
  "shiftedRight": "_shiftedRight_ia2wq9_566",
  "shiftedTop": "_shiftedTop_ia2wq9_567",
  "shiftedBottom": "_shiftedBottom_ia2wq9_568",
  "icon": "_icon_ia2wq9_570"
};
export { styles as default };
